// extracted by mini-css-extract-plugin
module.exports = {"metricCard":"MetricCard_metricCard__2rva5","container":"MetricCard_container__2ak0C","link":"MetricCard_link__2B2uN"};